import { Dispatch, useCallback } from 'react';
import { StatusType } from '../../../constants';
import { AvailabilityCurrentUserAction, AvailabilityCurrentUserActionType } from '../../../reducer';
import { CurrentAvailabilityUser } from '../../../types';
import useAvailabilityUserService from '../../../useAvailabilityUserService';

type UseAvailabilityCurrentUserActionsParams = Readonly<{
  currentUser: CurrentAvailabilityUser | null;
  dispatch: Dispatch<AvailabilityCurrentUserAction>;
}>;

const useAvailabilityCurrentUserActions = ({ currentUser, dispatch }: UseAvailabilityCurrentUserActionsParams) => {
  const { updateCurrentAvailabilityUserStatus } = useAvailabilityUserService();

  const initCurrentUser = useCallback(
    (user: CurrentAvailabilityUser) => {
      dispatch({ type: AvailabilityCurrentUserActionType.InitSuccess, payload: user });
    },
    [dispatch],
  );

  const setCurrentUserStatus = useCallback(
    (status: StatusType) => {
      dispatch({ type: AvailabilityCurrentUserActionType.SetStatus, payload: status });
    },
    [dispatch],
  );

  const setStatus = useCallback(
    async (status: StatusType, previousStatusOverride?: StatusType) => {
      const previousStatus = previousStatusOverride ?? currentUser?.status;

      setCurrentUserStatus(status);

      try {
        await updateCurrentAvailabilityUserStatus(status);
      } catch {
        if (previousStatus) {
          setCurrentUserStatus(previousStatus);
        }
      }
    },
    [currentUser?.status, setCurrentUserStatus, updateCurrentAvailabilityUserStatus],
  );

  return {
    initCurrentUser,
    setCurrentUserStatus,
    setStatus,
  };
};

export default useAvailabilityCurrentUserActions;
